

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstatisticasVeiculoComponent } from './estatisticas-veiculo.component';
import { EstatisticasVeiculoService } from '../../services/estatisticas-veiculo.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ModulosDeFormulario } from 'src/app/utils/formsModules';


@NgModule({
  declarations: [
    EstatisticasVeiculoComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    MatProgressSpinnerModule,
    ModulosDeFormulario
  ],
  exports: [
    EstatisticasVeiculoComponent
  ], 
  providers: [
    EstatisticasVeiculoService
  ]
})

export class EstatisticasModule { }